import * as React from 'react'
import { cn } from '@/lib/utils'

export type InputProps = React.InputHTMLAttributes<HTMLInputElement>

const Input = React.forwardRef<HTMLInputElement, InputProps>(({ className, type, ...props }, ref) => (
  <input
    type={type}
    className={cn(
      'flex h-8 w-full border border-[#222] bg-[#0d0d0d] px-3 py-1 text-[11px] font-mono text-[#e8e8e8] placeholder:text-[#444] focus:outline-none focus:ring-1 focus:ring-[#00ff88] focus:border-[#00ff88] disabled:cursor-not-allowed disabled:opacity-50 transition-colors',
      className
    )}
    ref={ref}
    {...props}
  />
))
Input.displayName = 'Input'
export { Input }
